import React, { Component } from 'react';
import { translate } from 'react-i18next';
import WorkplanArchiveSettings from './WorkplanArchiveSettings';
import ActionButtons from '../../../common/components/UI/ActionButtons/ActionButtons';
import './GlobalSetupForm.scss';

/**
 * @param {{
 *  isGlobalSetupLoading: boolean;
 *  globalSetup: *;
 *  onSave: (data: *) => void;
 *  t: *;
 * }} param0
 */
class GlobalSetupForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: props.globalSetup,
            errors: {},
            isDirty: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.globalSetup !== this.props.globalSetup) {
            this.setState({
                formData: this.props.globalSetup,
                isDirty: false,
            });
        }
    }

    handleChange = (name, value) => {
        this.setState(prevState => {
            const newFormData = {
                ...prevState.formData,
                [name]: value,
            };

            // Validate in real-time to clear errors when value becomes valid
            const newErrors = { ...prevState.errors };

            // Validate autoArchiveStoppedWorkplansDelay
            if (name === 'autoArchiveStoppedWorkplansDelay') {
                const delay = value;
                if (newFormData.isEnabledAutoArchiveStoppedWorkplans) {
                    if (delay < 0 || delay > 365 || isNaN(delay)) {
                        newErrors.autoArchiveStoppedWorkplansDelay = true;
                    } else {
                        delete newErrors.autoArchiveStoppedWorkplansDelay;
                    }
                } else {
                    delete newErrors.autoArchiveStoppedWorkplansDelay;
                }
            }

            // Clear error when toggle is disabled
            if (name === 'isEnabledAutoArchiveStoppedWorkplans' && !value) {
                delete newErrors.autoArchiveStoppedWorkplansDelay;
            }

            return {
                formData: newFormData,
                errors: newErrors,
                isDirty: true,
            };
        });
    };

    handleSave = () => {
        const { formData } = this.state;
        const { onSave } = this.props;

        // Validate
        const errors = {};
        if (formData.isEnabledAutoArchiveStoppedWorkplans) {
            const delay = formData.autoArchiveStoppedWorkplansDelay;
            if (delay < 0 || delay > 365 || isNaN(delay)) {
                errors.autoArchiveStoppedWorkplansDelay = true;
            }
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        onSave(formData);
        this.setState({ isDirty: false, errors: {} });
    };

    handleReset = () => {
        this.setState({
            formData: this.props.globalSetup,
            isDirty: false,
            errors: {},
        });
    };

    render() {
        const { isGlobalSetupLoading, t } = this.props;
        const { formData, errors, isDirty } = this.state;
        const hasError = Object.keys(errors).length > 0;
        const isLoading = isGlobalSetupLoading;

        return (
            <div className="global-setup-form">
                <WorkplanArchiveSettings
                    isLoading={isLoading}
                    step={1}
                    t={t}
                    formData={formData}
                    errors={errors}
                    onChange={this.handleChange}
                />
                <div className="global-setup-action-buttons-wrapper">
                    <ActionButtons
                        submit={this.handleSave}
                        cancel={this.handleReset}
                        disabledSubmit={isLoading || !isDirty || hasError}
                        submitText={t('common:Action.save')}
                        cancelText={t('common:Action.cancel')}
                    />
                </div>
            </div>
        );
    }
}

export default translate('workplanManager')(GlobalSetupForm);

